// extracted by mini-css-extract-plugin
export default {"container":"StageContent_container__9h2tB","illustration":"StageContent_illustration__UJHba","content":"StageContent_content__0B0z-"};